import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import ResponsiveDialog from 'components/Common/ResponsiveDialog';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Table,
  TableBody,
  Typography,
} from '@mui/material';
import { closeAllModals } from 'reducers/modalReducer';
import Box from '@mui/material/Box';
import { ReactComponent as HistoryIcon } from 'assets/icons/history.svg';
import EditHistoryTable from 'views/EditHistory/EditHistoryTable';
import { SkeletonTableRow } from 'components/Common/SkeletonTableRow';

type Props = {
  data: any;
  isFetching: boolean;
};

const EditHistoryModalContent = ({ data, isFetching }: Props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <ResponsiveDialog id="revision-history-modal" size="lg">
      <DialogTitle>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <HistoryIcon />
          <Typography variant="h4" sx={{ marginLeft: '12px' }}>
            {t('revisionHistory.title', 'Change history')}
          </Typography>
          <Divider variant="fullWidth" color="primary" />
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ width: '100%' }}>
          {isFetching ? (
            <Table sx={{ minWidth: 650 }}>
              <TableBody>
                <SkeletonTableRow rowCount={5} cellCount={7} id="revision-table-skeleton" />
              </TableBody>
            </Table>
          ) : (
            <EditHistoryTable rawData={data} />
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={() => dispatch(closeAllModals())}
          id="revision-history-ok-button"
        >
          OK
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  );
};

export default EditHistoryModalContent;
